export default "__VITE_ASSET__Czfjip1X__"